import { render, staticRenderFns } from "./DefensaPage.vue?vue&type=template&id=76e6323b"
import script from "./DefensaPage.js?vue&type=script&lang=js&external"
export * from "./DefensaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports